/* src/routes/blog/marching-squares.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import Prism from "../../../_components/PrismJS.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import LinkExternal from "../../../_components/Link-External.svelte.js";
import Link from "../../../_components/Link.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import P5Canvas from "../../../_components/P5Canvas.svelte.js";
import FullScreen from "../../../_components/Full-Screen.svelte.js";
import sketch from "./marching-squares-js.js";

function create_default_slot_5(ctx) {
	let t;

	return {
		c() {
			t = text("Metaballs and Marching Squares");
		},
		l(nodes) {
			t = claim_text(nodes, "Metaballs and Marching Squares");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (31:2) <FullScreen>
function create_default_slot_4(ctx) {
	let p5canvas;
	let current;
	p5canvas = new P5Canvas({ props: { sketch } });

	return {
		c() {
			create_component(p5canvas.$$.fragment);
		},
		l(nodes) {
			claim_component(p5canvas.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(p5canvas, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(p5canvas.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(p5canvas.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(p5canvas, detaching);
		}
	};
}

// (35:2) <LinkExternal     href="https://github.com/Gaweph/p5-live-examples/tree/master/Random/MarchingSquares">
function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("Source");
		},
		l(nodes) {
			t = claim_text(nodes, "Source");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (41:4) <Link href="marching-squares-linear-interpolation">
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("Linear interpolation version");
		},
		l(nodes) {
			t = claim_text(nodes, "Linear interpolation version");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (39:2) <Callout>
function create_default_slot_1(ctx) {
	let t0;
	let link;
	let t1;
	let current;

	link = new Link({
			props: {
				href: "marching-squares-linear-interpolation",
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("A Less blocky\n    ");
			create_component(link.$$.fragment);
			t1 = text("\n    can be found in a future post");
		},
		l(nodes) {
			t0 = claim_text(nodes, "A Less blocky\n    ");
			claim_component(link.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n    can be found in a future post");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(link, target, anchor);
			insert(target, t1, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const link_changes = {};

			if (dirty & /*$$scope*/ 4) {
				link_changes.$$scope = { dirty, ctx };
			}

			link.$set(link_changes);
		},
		i(local) {
			if (current) return;
			transition_in(link.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(link.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(link, detaching);
			if (detaching) detach(t1);
		}
	};
}

// (21:0) <PostContents>
function create_default_slot(ctx) {
	let t0;
	let linkexternal0;
	let t1;
	let strong;
	let t2;
	let t3;
	let fullscreen;
	let t4;
	let br;
	let t5;
	let linkexternal1;
	let t6;
	let callout;
	let current;

	linkexternal0 = new LinkExternal({
			props: {
				href: "http://jamie-wong.com/2014/08/19/metaballs-and-marching-squares/",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	fullscreen = new FullScreen({
			props: {
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	linkexternal1 = new LinkExternal({
			props: {
				href: "https://github.com/Gaweph/p5-live-examples/tree/master/Random/MarchingSquares",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	callout = new Callout({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("My initial implementation of the **Marching Squares** algorithm, I was\n  insipred after reading\n  ");
			create_component(linkexternal0.$$.fragment);
			t1 = text("\n  by\n  ");
			strong = element("strong");
			t2 = text("Jamie Wong");
			t3 = space();
			create_component(fullscreen.$$.fragment);
			t4 = space();
			br = element("br");
			t5 = space();
			create_component(linkexternal1.$$.fragment);
			t6 = space();
			create_component(callout.$$.fragment);
		},
		l(nodes) {
			t0 = claim_text(nodes, "My initial implementation of the **Marching Squares** algorithm, I was\n  insipred after reading\n  ");
			claim_component(linkexternal0.$$.fragment, nodes);
			t1 = claim_text(nodes, "\n  by\n  ");
			strong = claim_element(nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t2 = claim_text(strong_nodes, "Jamie Wong");
			strong_nodes.forEach(detach);
			t3 = claim_space(nodes);
			claim_component(fullscreen.$$.fragment, nodes);
			t4 = claim_space(nodes);
			br = claim_element(nodes, "BR", {});
			t5 = claim_space(nodes);
			claim_component(linkexternal1.$$.fragment, nodes);
			t6 = claim_space(nodes);
			claim_component(callout.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(linkexternal0, target, anchor);
			insert(target, t1, anchor);
			insert(target, strong, anchor);
			append(strong, t2);
			insert(target, t3, anchor);
			mount_component(fullscreen, target, anchor);
			insert(target, t4, anchor);
			insert(target, br, anchor);
			insert(target, t5, anchor);
			mount_component(linkexternal1, target, anchor);
			insert(target, t6, anchor);
			mount_component(callout, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const linkexternal0_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal0_changes.$$scope = { dirty, ctx };
			}

			linkexternal0.$set(linkexternal0_changes);
			const fullscreen_changes = {};

			if (dirty & /*$$scope*/ 4) {
				fullscreen_changes.$$scope = { dirty, ctx };
			}

			fullscreen.$set(fullscreen_changes);
			const linkexternal1_changes = {};

			if (dirty & /*$$scope*/ 4) {
				linkexternal1_changes.$$scope = { dirty, ctx };
			}

			linkexternal1.$set(linkexternal1_changes);
			const callout_changes = {};

			if (dirty & /*$$scope*/ 4) {
				callout_changes.$$scope = { dirty, ctx };
			}

			callout.$set(callout_changes);
		},
		i(local) {
			if (current) return;
			transition_in(linkexternal0.$$.fragment, local);
			transition_in(fullscreen.$$.fragment, local);
			transition_in(linkexternal1.$$.fragment, local);
			transition_in(callout.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(linkexternal0.$$.fragment, local);
			transition_out(fullscreen.$$.fragment, local);
			transition_out(linkexternal1.$$.fragment, local);
			transition_out(callout.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(linkexternal0, detaching);
			if (detaching) detach(t1);
			if (detaching) detach(strong);
			if (detaching) detach(t3);
			destroy_component(fullscreen, detaching);
			if (detaching) detach(t4);
			if (detaching) detach(br);
			if (detaching) detach(t5);
			destroy_component(linkexternal1, detaching);
			if (detaching) detach(t6);
			destroy_component(callout, detaching);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "Marching Squares";
const date = "2019-07-09";

function instance($$self) {
	const tags = ["p5"];
	const projects = [];
	return [tags, projects];
}

class Marching_squares extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Marching_squares;
//# sourceMappingURL=marching-squares.svelte.js.map
